import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import { InlineMessage } from 'messages/components';

import { removeInlineMessage } from 'messages/actions';

class InlineMessagesConatiner extends PureComponent {
  static propTypes = {
    messages: PropTypes.object.isRequired,
    removeMessage: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
  };

  handleClose = (e, id) => {
    e.preventDefault();
    this.props.removeMessage(id);
  };

  render = () => {
    return this.props.messages ? (
      <Fragment>
        {this.props.messages &&
          Object.keys(this.props.messages).map((id) => (
            <InlineMessage
              key={id}
              display={!!this.props.messages[id].text}
              text={this.props.t(this.props.messages[id].text)}
              type={this.props.messages[id].type}
              handleClose={(e) => this.handleClose(e, id)}
            />
          ))}
      </Fragment>
    ) : null;
  };
}

const mapStateToProps = (state, ownProps) => ({
  messages: state.message.inline,
});

const mapDispatchToProps = { removeMessage: removeInlineMessage };

export default connect(mapStateToProps, mapDispatchToProps)(translate()(InlineMessagesConatiner));



// WEBPACK FOOTER //
// src/modules/messages/containers/InlineMessagesContainer.js